export default {
      id: "playCircleFilled-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#playCircleFilled-usage",
      toString: function () {
        return this.url;
      }
    }